let utils = require('../../actions/utils');
let redirect = require('../../actions/redirect');
let login = require('../../actions/auth/login');
let cookie = require('../../actions/cookie');
let user = require('../../actions/user');
let { loginSuccess } = require('../groups/auth/login');
let registrationExtra = require('../../actions/auth/registration-extra');
let analytics = require('../../actions/analytics');

module.exports = {
    clickLoginButton: [
        utils.set(['login', 'ui', 'loginButton', 'isDisabled'], true),
        [
            login.loginUser, {
                success: [
                    [
                        user.getUser, {
                            allowed: [
                                ...loginSuccess
                            ],
                            401: [
                                utils.set(['login', 'error', 'errorType'], 'accessDenied')
                            ],
                            403: [
                                cookie.setRegisterExtraToken,
                                utils.setFromArgsToState('username', ['login', 'tooltip', 'emailNotConfirmed',
                                    'username']),
                                utils.set(['login', 'tooltip', 'emailNotConfirmed', 'show'], true)
                            ],
                            404: [
                                cookie.setRegisterExtraToken,
                                redirect.redirect('/registration/extra')
                            ],
                            denied: [
                                utils.set(['login', 'error', 'errorType'], 'internalError')
                            ]
                        }
                    ]
                ],
                invalidValidation: [
                    utils.set(['login', 'error', 'errorType'], 'invalidValidation')
                ],
                accessDenied: [
                    utils.set(['login', 'error', 'errorType'], 'accessDenied')
                ],
                error: [
                    utils.set(['login', 'error', 'errorType'], 'internalError')
                ]
            }
        ],
        utils.set(['login', 'ui', 'loginButton', 'isDisabled'], false)
    ],
    clickRegisterButton: [
        analytics.argsValueEvent({ category: 'button_start_registration', action: 'click' }),
        login.passLoginInfoToRegistrationForm
    ],
    sendConfirmationMail: [
        registrationExtra.sendConfirmationMail,
        utils.unset(['login', 'tooltip', 'emailNotConfirmed', 'show']),
        utils.set(['login', 'tooltip', 'emailNotConfirmedMailResend', 'show'], true)
    ]
};



// WEBPACK FOOTER //
// ./signals/auth/login.js